import { API_ENDPOINTS } from "../../../../Api/apiEndPoints"
import axiosInstance from "../../../../Api/axiosInstance"
import { showToast } from "../../../../utils/toastUtils";

export const getExpenseNotifyList = async(params={})=>{
    
    let response = await axiosInstance.get(API_ENDPOINTS.EXPENSE_NOTIFY.GET_EXPENSE_NOTIFY_LIST,{params:params});
    const rowData =   await response.data;
   const formatedData  =  Array.isArray(rowData?.data?.data)
   ? rowData?.data?.data?.map((item:any)=>({
       
       OrgunitId:item?.OrgunitId || '-',
       unitName:item?.unit_name || '-',
       month:item?.Moye||'-',
       pndExpforSub:item?.UniquePendingForSubmit || '-',
       pndExpforApp:item?.UniquePendingForApprove ||'-',
       pndPunOut:item?.PendingPunchout ||'-',
       // org:item.org ||'-',
       
    })):[]   
    return{formatedData,rowData};
} 

export const sendNotifaction = async(params={})=>{
    let response = await axiosInstance.get(API_ENDPOINTS.EXPENSE_NOTIFY.GET_EXPENSE_NOTIFY_NOTIFICATION,{params:params})
    console.log('Notification Response:::',response);
    const msg:string = response?.data.message;
    showToast.success(msg);
}


